/** Solo es fiable el mensaje del iframe actualmente seleccionado. */
export function isCommandCenterReady(event, iframeWindow, expectedOrigin) {
  const data = event && event.data;
  return !!iframeWindow && !!event && event.source === iframeWindow &&
    event.origin === expectedOrigin && !!data && typeof data === "object" &&
    !Array.isArray(data) && data.type === "command-center:ready" &&
    data.version === 1;
}